module.exports = __webpack_public_path__ + "cf50a6ec0b814b1b6f1ff37c49a7d582.svg";